import { Divider, Grid } from "@mui/material";

import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import useAPI from "../../../../../../api/hooks/useAPI";
import useColors from "../../../../../../api/hooks/useColors";
import { remediationAuditLogKeys } from "../../../../../../api/queryKeys";
import { RemediationStatus } from "../../../../../../utils/constants";
import ControlEntitiesSection from "../../ControlMisconfiguration/ControlEntitiesSection";
import AuditLogsSection from "./AuditLogsSection";
import HeaderRemediationSection from "./RemediationHeader";
import RemediationSteps from "./RemediationSteps";

const RemediationTab = ({ selectedRemediation, demoMode, fullControl }) => {
  const colors = useColors();
  const { getRemediationAuditLogs } = useAPI();
  const [showDetailedAffectedEntities, setShowDetailedAffectedEntities] =
    useState(false);

  const { data: auditLogs, isSuccess: isSuccessAuditLogs } = useQuery({
    queryKey: remediationAuditLogKeys.auditLogs(fullControl?.control_id),
    queryFn: async () => {
      const auditLogs = await getRemediationAuditLogs(fullControl?.control_id);
      return auditLogs;
    },
    select: (response) => response?.data,
    enabled: fullControl !== null,
  });

  return (
    <div>
      {selectedRemediation && (
        <>
          <Grid container gap={2} mb={3}>
            <Grid
              item
              xs={12}
              sx={{
                position: "sticky",
                top: 0,
                zIndex: 1,
                backgroundColor: colors.grey_50,
                boxShadow: `0px -3px 0px 3px ${colors.grey_50}`,
              }}
            >
              <Grid container direction="column" gap={2}>
                <HeaderRemediationSection
                  selectedRemediation={selectedRemediation}
                  demoMode={demoMode}
                  fullControl={fullControl}
                />
              </Grid>
              <Grid item xs={12} my={1.5}>
                <Divider orientation="horizontal" flexItem />
              </Grid>
            </Grid>

            {selectedRemediation.status !== RemediationStatus.RESOLVED &&
              fullControl.is_gap && (
                <Grid item xs={12}>
                  <ControlEntitiesSection
                    fullControl={fullControl}
                    showDetailedAffectedEntities={showDetailedAffectedEntities}
                    setShowDetailedAffectedEntities={
                      setShowDetailedAffectedEntities
                    }
                    defaultCollapsed={true}
                  />
                </Grid>
              )}
            {!showDetailedAffectedEntities && (
              <Grid item xs={12} mt={1}>
                {fullControl && <RemediationSteps fullControl={fullControl} />}
              </Grid>
            )}
            {!showDetailedAffectedEntities &&
              isSuccessAuditLogs &&
              auditLogs?.length > 0 && (
                <Grid item xs={12}>
                  <AuditLogsSection auditLogs={auditLogs} />
                </Grid>
              )}
          </Grid>
        </>
      )}
    </div>
  );
};

export default RemediationTab;
